import { Alert, Row, Col, Form } from 'reactstrap';

// hooks
import { useRedux } from '../../hooks/index';
import { createSelector } from 'reselect';
// validations
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';

// // hooks
import { useProfile } from '../../hooks';

//actions
import { userChangePassword } from '../../redux/actions';

// components
import NonAuthLayoutWrapper from '../../components/NonAutnLayoutWrapper';
import AuthHeader from '../../components/AuthHeader';
import FormInput from '../../components/FormInput';
import Loader from '../../components/Loader';

//images
import avatar from '../../assets/images/users/user-dummy-img.jpg';
import { useNavigate } from 'react-router-dom';

interface ChangePasswordProps {}
const ChangePassword = (props: ChangePasswordProps) => {
    // global store
    const { dispatch, useAppSelector } = useRedux();
    const navigate = useNavigate();

    // const { changepasswordError, passwordChanged, changePassLoading } =
    //   useAppSelector(state => ({
    //     passwordChanged: state.ForgetPassword.passwordChanged,
    //     changepasswordError: state.ForgetPassword.changepasswordError,
    //     changePassLoading: state.ForgetPassword.loading,
    //   }));

    const errorData = createSelector(
        (state: any) => state.ForgetPassword,
        (state) => ({
            passwordChanged: state.passwordChanged,
            changepasswordError: state.changepasswordError,
            changePassLoading: state.loading
        })
    );
    // Inside your component
    const { passwordChanged, changepasswordError, changePassLoading } =
        useAppSelector(errorData);

    const resolver = yupResolver(
        yup.object().shape({
            oldPassword: yup.string().required('Please Enter Old Password.'),
            newPassword: yup.string().required('Please Enter New Password.'),
            newPasswordVerify: yup
                .string()
                .oneOf([yup.ref('newPassword')], "Passwords don't match")
                .required('This value is required.')
        })
    );

    const defaultValues: any = {};

    const methods = useForm({ defaultValues, resolver });
    const {
        handleSubmit,
        register,
        control,
        formState: { errors }
    } = methods;

    const onSubmitForm = (values: object) => {
        dispatch(userChangePassword(values));
    };

    const { userProfile } = useProfile();

    return (
        <NonAuthLayoutWrapper>
            <Row className=" justify-content-center my-auto">
                <Col sm={8} lg={6} xl={5} className="col-xxl-4">
                    <div className="py-md-5 py-4">
                        <AuthHeader title="Change Password" />
                        <div className="user-thumb text-center mb-4">
                            <img
                                src={avatar}
                                className="rounded-circle img-thumbnail avatar-lg"
                                alt="thumbnail"
                            />
                            <h5 className="font-size-15 mt-3">
                                {`${userProfile.data.user.person.firstName} ${userProfile.data.user.person.lastName}`}
                            </h5>
                        </div>
                        {changepasswordError && changepasswordError ? (
                            <Alert color="danger">{changepasswordError}</Alert>
                        ) : null}
                        {passwordChanged ? (
                            <Alert color="success">
                                Your Password is changed
                            </Alert>
                        ) : null}

                        <Form
                            onSubmit={handleSubmit(onSubmitForm)}
                            className="position-relative"
                        >
                            {changePassLoading && <Loader />}
                            <div className="mb-3">
                                <FormInput
                                    label="Old Password"
                                    type="password"
                                    name="oldPassword"
                                    register={register}
                                    errors={errors}
                                    control={control}
                                    labelClassName="form-label"
                                    placeholder="Enter Old Password"
                                    className="form-control"
                                    withoutLabel={true}
                                    hidePasswordButton={true}
                                />
                            </div>
                            <div className="mb-3">
                                <FormInput
                                    label="New Password"
                                    type="password"
                                    name="newPassword"
                                    register={register}
                                    errors={errors}
                                    control={control}
                                    labelClassName="form-label"
                                    placeholder="Enter New Password"
                                    className="form-control"
                                    withoutLabel={true}
                                    hidePasswordButton={false}
                                />
                            </div>
                            <div className="mb-3">
                                <FormInput
                                    label="Confirm New Password"
                                    type="password"
                                    name="newPasswordVerify"
                                    register={register}
                                    errors={errors}
                                    control={control}
                                    labelClassName="form-label"
                                    placeholder="Enter Confirm Password"
                                    className="form-control"
                                    withoutLabel={true}
                                    hidePasswordButton={true}
                                />
                            </div>

                            <div className="text-center mt-4">
                                <div className="row">
                                    <div className="col-6">
                                        <button
                                            className="btn btn-primary w-100"
                                            type="submit"
                                        >
                                            Save
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            className="btn btn-light w-100"
                                            type="button"
                                            onClick={() => {
                                                navigate(-1);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </NonAuthLayoutWrapper>
    );
};

export default ChangePassword;
